/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as TeamDefs from './defs.defs.js'

const $nsid = 'tools.ozone.team.updateMember'

export { $nsid }

/** Update a member in the ozone service. Requires admin role. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    did: l.string({ format: 'did' }),
    disabled: l.optional(l.boolean()),
    role: l.optional(
      l.string<{
        knownValues: [
          'tools.ozone.team.defs#roleAdmin',
          'tools.ozone.team.defs#roleModerator',
          'tools.ozone.team.defs#roleVerifier',
          'tools.ozone.team.defs#roleTriage',
        ]
      }>(),
    ),
  }),
  l.payload(
    'application/json',
    l.ref<TeamDefs.Member>((() => TeamDefs.member) as any),
  ),
  ['MemberNotFound'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
